import format from 'date-fns/format';
import sk from 'date-fns/locale/sk';

export default (date: string | number | Date, formatStr?: string) => {
  return format(date, formatStr, {
    locale: sk,
  });
};
